export default __webpack_public_path__ + "static/media/banner-bg.1d20b6ac.jpg";